import {filter, map, shareReplay, startWith} from 'rxjs/operators';
import {envUtil} from '@/helper/env';
import {genShareReplyWithSubscribeHook} from '@/helper/stream';
import {wwData$} from '../worker-data';
import {loadAssetsOverviewData$} from '../data/assets';
import {isLogin$} from '../auth';
import type {AssetsOverview} from '@px/ws-data';

export interface TotalAssets extends AssetsOverview {
  isInit?: boolean;
}

export const totalAssets$ = genShareReplyWithSubscribeHook(
  wwData$.pipe(
    filter((o) => o.type === 'assets'),
    map((o) => o.data.assets),
    startWith(initAssets()),
    shareReplay(1)
  ),
  () => {
    if (envUtil.isServer) {
      return;
    }
    const isLogin = isLogin$.getValue();
    if (!isLogin) {
      return;
    }
    loadAssetsOverviewData$.next();
  }
);

export function initAssets(): TotalAssets {
  const asset = {
    btcEv: 0,
    btc: '--',
    usdEv: 0,
    usd: '--',
    money: '--',
    usdtEv: 0,
    usdt: '--',
  };
  return {
    isInit: true,
    ...asset,
    localCurrency: '',
    details: {
      spot: asset,
      spotMargin: asset,
      spotStrategy: asset,
      contract: asset,
      contractStrategy: asset,
      copyTrade: asset,
      investment: asset,
      fiat: asset,
      lending: asset,
      trading: asset,
      funding: asset,
      spotAll: asset,
      contractAll: asset,
      tradingAll: asset,
      tradingBot: asset,
      memeTrade: asset,
    },
  };
}
